export const adminMobileChrome = {
  showBrandHeader: false,
  showLogout: true,
  showThemeToggle: true,
  contentTop: 16,
} as const
